var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { DotsLoader, Loader } from "@brushfire/ui";
import React from "react";
import { getWidgetConfig, postThirdPartData } from "../data/api";
import WidgetClientWrapper from "../WidgetClientWrapper";
import Oops from "./Pages/Oops/Oops";
import { log, Style } from "../data/helpers";
import CookieWarning from "./Pages/CookieWarning/CookieWarning";
import { localTest } from "../data/localStorageHelpers";
export var WidgetContext = React.createContext({
    theme: {},
    isWidget: true,
    isPortal: false,
    darkMode: false,
    failedToLoad: false,
    showLoader: false,
    showGlobalLoader: false,
    setShowGlobalLoader: function (show) {
        return null;
    },
    setGASessions: function (setGASessions) {
        return null;
    },
    gaSessions: {},
    setDarkMode: function (darkMode) {
        return null;
    },
});
var Widget = /** @class */ (function (_super) {
    __extends(Widget, _super);
    function Widget(props) {
        var _this = _super.call(this, props) || this;
        _this.setShowGlobalLoader = function (show) {
            _this.setState({ showGlobalLoader: show });
        };
        _this.setGASessions = function (gaSessions) {
            _this.setState({ gaSessions: gaSessions });
        };
        _this.state = {
            theme: {},
            host: undefined,
            widgetId: undefined,
            widgetConfig: undefined,
            isWidget: true,
            isPortal: false,
            darkMode: false,
            failedToLoad: false,
            showLoader: false,
            showGlobalLoader: true,
            gaSessions: {},
        };
        return _this;
    }
    Widget.prototype.render = function () {
        var _this = this;
        var getContent = function () {
            if (_this.state.host === undefined || _this.state.widgetId === undefined) {
                return null;
            }
            else {
                return (_jsx(WidgetContext.Provider, __assign({ value: __assign(__assign({}, _this.state), { setShowGlobalLoader: _this.setShowGlobalLoader, setGASessions: _this.setGASessions, setDarkMode: _this.setDarkMode }) }, { children: _jsx(WidgetClientWrapper, __assign({ theme: _this.state.theme }, _this.props, { isWidget: _this.state.isWidget })) })));
            }
        };
        if (this.state.failedToLoad) {
            return _jsx(Oops, { refresh: true });
        }
        // cookies check
        if (!localTest()) {
            return _jsx(CookieWarning, {});
        }
        return (_jsxs(_Fragment, { children: [(((this.state.host === undefined || this.state.widgetId === undefined) && this.state.showLoader) ||
                    this.state.showGlobalLoader) && (_jsx(Loader, { customLoadingIcon: _jsx(DotsLoader, { containerClasses: "global-loader-container" }), classes: "global-loader higher" })), getContent()] }));
    };
    Widget.prototype.setTheme = function (theme) {
        this.setState({ theme: theme });
    };
    Widget.prototype.setHost = function (host) {
        if (!this.state.host) {
            window.widgetHost = host;
            this.setState({ host: host });
        }
    };
    Widget.prototype.setCombinedWidgetConfig = function (widgetId, data, externalWidgetConfig) {
        if (externalWidgetConfig === void 0) { externalWidgetConfig = {}; }
        var combinedWidgetConfig = Object.assign({}, data, externalWidgetConfig);
        Object.keys(externalWidgetConfig).forEach(function (key) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            if (externalWidgetConfig[key] === "") {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                delete combinedWidgetConfig[key];
            }
        });
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        if (combinedWidgetConfig.action === undefined ||
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            combinedWidgetConfig.action === "" ||
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            combinedWidgetConfig.action === null) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            combinedWidgetConfig.action = "smart";
        }
        this.setState({ widgetId: widgetId, widgetConfig: data, combinedWidgetConfig: combinedWidgetConfig, externalWidgetConfig: externalWidgetConfig });
    };
    Widget.prototype.setWidgetId = function (widgetId, externalWidgetConfig) {
        var _this = this;
        if ((externalWidgetConfig === null || externalWidgetConfig === void 0 ? void 0 : externalWidgetConfig.u) === "*") {
            widgetId = "276c2bb4-9bef-4b58-8b65-f66d4a88c49c";
        }
        if ((externalWidgetConfig === null || externalWidgetConfig === void 0 ? void 0 : externalWidgetConfig.darkMode) !== undefined) {
            this.setDarkMode(externalWidgetConfig.darkMode);
        }
        if ((externalWidgetConfig === null || externalWidgetConfig === void 0 ? void 0 : externalWidgetConfig.debugMode) !== undefined) {
            log("Debug mode enabled", Style.success);
            console.log("Debug Mode: ", externalWidgetConfig.debugMode);
            window.brushfireDebugMode = externalWidgetConfig.debugMode;
        }
        if (widgetId !== this.state.widgetId) {
            window.widgetId = widgetId;
            if (widgetId !== "276c2bb4-9bef-4b58-8b65-f66d4a88c49c") {
                this.setState({ showLoader: true });
                getWidgetConfig(widgetId)
                    .then(function (_a) {
                    var data = _a.data;
                    _this.setCombinedWidgetConfig(widgetId, data, externalWidgetConfig);
                })
                    .catch(function () {
                    _this.setCombinedWidgetConfig(widgetId, undefined, externalWidgetConfig);
                });
            }
            else {
                if ((externalWidgetConfig === null || externalWidgetConfig === void 0 ? void 0 : externalWidgetConfig.u) !== "*") {
                    this.setState({ isWidget: false, isPortal: true });
                }
                this.setCombinedWidgetConfig(widgetId, undefined, externalWidgetConfig);
            }
        }
    };
    Widget.prototype.setAccount = function (externalAccount) {
        this.setState({ externalAccount: externalAccount });
        if (externalAccount === null || externalAccount === void 0 ? void 0 : externalAccount.thirdPartyCustomerId) {
            postThirdPartData(__assign({}, externalAccount));
        }
    };
    Widget.prototype.setDarkMode = function (darkMode) {
        debugger;
        this.setState({ darkMode: darkMode });
    };
    return Widget;
}(React.Component));
export default Widget;
